import Vue from "vue";
import { Permissions } from "@/lib/utilities/enums";

export default {
  async fetchOrgTeams() {
    const req = Vue.http.get("/grouphours/orgteams");
    const resp = (await req).data;

    if (resp.Success && Array.isArray(resp.Data)) return resp.Data;
    else {
      console.error("getOrgTeams: Failed to fetch...");
      console.error(resp);
      throw resp;
    }
  },
  async fetchWorkscheduleAdmins() {
    const req = Vue.http.get(`rolepermissions/permissions/${Permissions.WorkscheduleAdmin}`);
    const resp = (await req).data;

    if (resp.Success && Array.isArray(resp.Data)) return resp.Data;
    else {
      console.error("fetchSchedulerAdmin: Failed to fetch");
      console.error(resp);
      throw resp;
    }
  },
  async setWorkscheduleAdmins(userIds) {
    if (!Array.isArray(userIds)) userIds = [userIds];
    const req = Vue.http.post("/rolepermissions/permissionforusers", {
      userIds: userIds,
      permissionId: Permissions.WorkscheduleAdmin,
    });
    const resp = (await req).data;

    if (resp.Success && Array.isArray(resp.Data)) return resp.Data;
    else {
      console.error("addPermissionToUsers: Failed to post");
      console.error(resp);
      throw resp;
    }
  },
  async fetchAllPermissions() {
    const req = Vue.http.get("/rolepermissions/managepermissions");
    const resp = (await req).data;

    if (resp.Success && Array.isArray(resp.Data)) return resp.Data;
    else {
      console.error("getAllPermissions: Failed to fetch permissions");
      console.error(resp);
      throw resp;
    }
  },
  async saveWorkscheduleAutoCopy(teams) {
    const req = Vue.http.post("/grouphours/setautocopyschedule", teams);
    const resp = (await req).data;

    if (resp.Success && Array.isArray(resp.Data)) return resp.Data;
    else {
      console.error("saveWorkscheduleAutoCopy: Failed to save");
      console.error(resp);
      throw resp;
    }
  },
  async saveWorkscheduleTeamSchedule(teams) {
    if (!Array.isArray(teams)) teams = [teams];
    const req = Vue.http.put("/grouphours", teams);
    const resp = (await req).data;

    if (resp.Success) return resp.Data;
    else {
      console.error("saveWorkscheduleTeamSchedule: Failed to save");
      console.error(resp);
      throw resp;
    }
  },
  async createUserSchedules(schedulesToAdd) {
    if (!Array.isArray(schedulesToAdd)) schedulesToAdd = [schedulesToAdd];
    const req = Vue.http.post("/userschedule", schedulesToAdd);
    const resp = (await req).data;

    if (resp.Success) return resp.Data;
    else {
      console.error("deleteUserSchedules: Failed to update");
      console.error(resp);
      throw resp;
    }
  },
  async deleteUserSchedules(schedulesToDelete) {
    if (!Array.isArray(schedulesToDelete)) schedulesToDelete = [schedulesToDelete];
    const req = Vue.http.delete("/userschedule", { data: schedulesToDelete });
    const resp = (await req).data;

    if (resp.Success) return resp.Data;
    else {
      console.error("deleteUserSchedules: Failed to update");
      console.error(resp);
      throw resp;
    }
  },
  async updateUserSchedules(schedulesToUpdate) {
    if (!Array.isArray(schedulesToUpdate)) schedulesToUpdate = [schedulesToUpdate];
    const req = Vue.http.put("/userschedule", schedulesToUpdate);
    const resp = (await req).data;

    if (resp.Success) return resp.Data;
    else {
      console.error("updateUserSchedules: Failed to update");
      console.error(resp);
      throw resp;
    }
  }
};


// WEBPACK FOOTER //
// ./src/services/api/index.js